import { memo, useCallback, useContext } from 'react'

import { AuthContext, useAuth } from '../../AuthContext'
import { useResetPassword } from '../../hooks/user'
import { ResetPasswordForm } from './components'
import { ResetPasswordFormValue } from './components/ResetPasswordForm'

import * as SC from './styles'

export const ResetPassword = memo(() => {
  const { portalName } = useContext(AuthContext)
  const resetPasswordMutation = useResetPassword(portalName)
  const { logoElement, footer } = useAuth()

  const resetPassword = useCallback(
    (value: ResetPasswordFormValue) => resetPasswordMutation.mutateAsync(value),
    [resetPasswordMutation]
  )

  return (
    <SC.Box>
      <ResetPasswordForm onSubmit={resetPassword} logoElement={logoElement} footer={footer} />
    </SC.Box>
  )
})
